<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(null)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <!-- Info -->
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Aproval Status</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="statusAproval"
          :reduce="(v) => v.id"
          class="w-full"
          label="text"
          :clearable="false"
          v-model="formData.status"
          placeholder="Status Aproval"
        />
      </div>
      <div class="mb-6" v-if="formData.status === 2">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Keterangan Tidak Menyetujui</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-textarea
          class="w-full sidebar-input"
          v-model="formData.deskripsi"
          placeholder="Isi Dengan Keterangan Tidak Menyetujui"
        />
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(null)"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 rounded-2xl"
          @click="
            closeWithLoad({
              activate: false,
              file: formData,
            })
          "
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";

export default {
  props: {
    activate: { type: Boolean, default: false },
    itemPassData: { type: Object, default: null },
  },
  data() {
    return {
      url,
      emptyImage,
      statusAproval: [
        {
          id: 1,
          text: "Disetujui",
        },
        {
          id: 2,
          text: "Tidak Disetujui",
        },
      ],
      formData: {
        id: null,
        status: 2,
        deskripsi: "-",
      },
    };
  },
  computed: {
    titlePopUp() {
      return this.itemPassData !== null
        ? `Aproval Syarat ${this.itemPassData.nameSyarat}`
        : "";
    },
    labelButton() {
      return this.itemPassData !== null ? "Edit" : "Submit";
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
    status() {
      return this.formData.status;
    },
  },
  watch: {
    activate() {
      if (this.itemPassData !== null) {
        this.formData.id = this.itemPassData.syarat.id;
        this.formData.status = this.itemPassData.status;
        this.formData.deskripsi = this.itemPassData.deskripsi;
      } else {
        this.resetForm();
      }
    },
    status() {
      if (this.status === 1) {
        this.formData.deskripsi = "-";
      }
    },
  },
  methods: {
    resetForm() {
      this.formData.id = null;
      this.formData.status = 2;
      this.formData.deskripsi = "-";
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
      this.resetForm();
    },
  },
};
</script>

<style scoped>
.text-red {
  color: red;
}
.text-blue {
  color: blue;
}
.text-grey-black {
  color: rgb(70, 70, 70);
}
img {
  max-height: 400px;
  overflow: auto;
}
</style>
